<template>
  <div
    :class="$style.root"
    @keyup.esc="closeSelf()"
    tabindex="0"
    ref="element"
  >
    <div :class="$style.breakCrumbs" :data-sticky="sticky ? '' : null">
      <i18nLink to="index" class="reset-link link">{{ $t('siteTitle') }}</i18nLink>
      <i18nLink
        :to="parent"
        class="reset-link link"
      >
          {{ parentTitle || $t('shared.close') }}
      </i18nLink>
    </div>
    <div :class="$style.content">
      <slot name="content" />
    </div>
    <div :class="$style.close">
      <slot name="close" />
    </div>
  </div>
</template>

<script setup>
const { y } = useWindowScroll()
const element = ref(null)
const localePath = useLocalePath()
const nuxtApp = useNuxtApp()
const parent = nuxtApp.$getRouteBaseName()?.replace('-slug', '')
const router = useRouter()

const props = defineProps({
  parentTitle: {
    type: String,
    required: false
  },
})

const closeSelf = () => {
  router.push(localePath({ name: parent }))
}

onMounted(() => {
  if (process.client) {
    element.value.focus()
    window.scrollTo(0, 0)
  }
})

const prevYValue = ref(0)
const sticky = ref(false)
watch(y, (value) => {
  const dirUp = prevYValue.value > value
  sticky.value = dirUp && value > 0
  prevYValue.value = value
})
</script>

<style module lang="scss">
.root {
  display: grid;
  // NOTE the calculation should be based on a var that knows about the width of the close svg
  --column: calc(100% - (var(--unit--default) * 2) - var(--size--button));
  grid-template-columns: 1fr min( var(--container--default), var(--column) ) 1fr;
  // grid-column-gap: var(--unit--default);
  grid-row-gap: var(--unit--default);
  grid-template-areas:  'breadCrumbs breadCrumbs closeButton'
                        'margin-left content margin-right';
  // align-items: start;

  position: relative;

  @media (max-width: $breakpoint-xl) {
    grid-template-columns: 1fr min( var(--container--default), var(--column) ) 1fr;
    grid-template-areas:  'breadCrumbs closeButton'
                          'margin-left content margin-right';
  }

  @media (max-width: $breakpoint-m) {
    grid-template-columns: 1fr min-content;
    grid-template-areas:  'breadCrumbs closeButton'
                          'content content';
  }
}

.root:focus {
  outline: none;
}

.breakCrumbs {
  composes: font-size-default from global;
  grid-area: breadCrumbs;

  display: flex;
  align-items: baseline;
  gap: var(--unit--default);

  height: var(--font-default--line-height);
  padding: var(--unit--default) 0;
  // margin-top: calc(var(--unit--default) * -1);

  // background-color: var(--color--background);
}

.breakCrumbs[data-sticky] {
  position: sticky;
  top: 0;
  z-index: 101;

  background-color: var(--color--background);

  width: calc(100% + var(--size--button));
}

.breakCrumbs div:hover {
  color: var(--color--magenta);
}

.content {
  grid-area: content;

  margin-top: calc(var(--font-default--line-height) * -1);
  @media (max-width: $breakpoint-xl) {
    margin-top: 0;
  }
}

.close {
  grid-area: closeButton;

  display: flex;
  justify-content: flex-end;
  align-self: start;

  position: sticky;
  top: var(--unit--vertical);
  z-index: 102;
}

.close a:hover {
  color: var(--color--magenta);
}

</style>
